import React, { useEffect, useState } from "react";
import { auth, db } from "../../config/firebaseConfig";
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import styles from "./SelectProject.module.css";

const SelectProject = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchUserProjects = async () => {
    const user = auth.currentUser;
    if (!user) return;

    try {
      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        console.warn("ユーザー情報が見つかりませんでした");
        return;
      }

      const assignedProjectIDs = userSnap.data().assignedProjects || [];

      if (assignedProjectIDs.length === 0) {
        setProjects([]);
        return;
      }

      const q = query(
        collection(db, "projects"),
        where("__name__", "in", assignedProjectIDs),
      );
      const snapshot = await getDocs(q);
      const result = snapshot.docs.map(doc => ({
        id: doc.id,
        name: doc.data().name || "無名プロジェクト",
        description: doc.data().description || ""
      }));

      setProjects(result);
    } catch (error) {
      console.error("プロジェクト情報の取得に失敗:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (projectID, projectName) => {
    localStorage.setItem("currentProjectID", projectID);
    localStorage.setItem("currentProjectName", projectName);
    navigate("/");
  };

  useEffect(() => {
    fetchUserProjects();
  }, []);

  if (loading) return <p>読み込み中...</p>;

  return (
    <div className={styles.container}>
      <h2>プロジェクトを選択してください</h2>
      {projects.length === 0 ? (
        <p>所属しているプロジェクトがありません。</p>
      ) : (
        <ul className={styles.projectLists}>
          {projects.map((proj) => (
            <li key={proj.id} className={styles.projectItem}>
              <button
                className={styles.projectButton}
                onClick={() => handleSelect(proj.id, proj.name)}
              >
                <div className={styles.projectName}>{proj.name}</div>
                <div className={styles.projectDescription}>{proj.description}</div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SelectProject;
